import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { groupBy } from "core/util/array";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import TransferDateCard from "./TransferDateCard";
import { Box } from "@mui/material";
import { useSafeArea } from "app/layout/Navbar/useSafeArea";
const MobileTransfers = ({ transfers, setTransferView, }) => {
    const [isVisible, setIsVisible] = useState(false);
    const { insetBottom } = useSafeArea();
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    const toggleVisibility = () => {
        if (window.scrollY > 300) {
            setIsVisible(true);
        }
        else {
            setIsVisible(false);
        }
    };
    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
    }, []);
    const groupedTransfers = transfers === undefined
        ? []
        : groupBy(transfers, (transfer) => dayjs(transfer.NextScheduledDate).endOf("day").toDate(), (firstElement, secondElement) => secondElement.valueOf() - firstElement.valueOf());
    const groupedTransfersList = groupedTransfers.map((x) => (_jsx(TransferDateCard, { date: x.key, transfers: x.elements, setTransferView: setTransferView }, x.key.toUTCString())));
    return (_jsxs("div", { className: "mobile-transaction-list-container", children: [groupedTransfersList, _jsx("div", { className: "scroll-to-top", children: isVisible && (_jsxs(_Fragment, { children: [_jsx("div", { className: "btn-scroll", onClick: scrollToTop, children: _jsx(ArrowUpwardIcon, {}) }), _jsx(Box, { height: `${insetBottom}px` })] })) }), _jsx("p", { className: "dataEnd", children: "There are no more items to display." }), _jsx("hr", {})] }));
};
export default MobileTransfers;
